export default __webpack_public_path__ + "static/media/selectedCircle.5597e8fa.svg";